import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from './app.constant';
import { environment } from '../environments/environment';
import { CustomSpinnerComponent } from './shared/components/custom-spinner/custom-spinner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'SOFIA';
  customSpinnerComponent = CustomSpinnerComponent;
  languageList = AppConstants.Languages.AllLanguages;
  defaultLanguage = AppConstants.Languages.DefaultLanguage;
  federaleURL = environment.wwwFederale + this.defaultLanguage;

  constructor(public translate: TranslateService) {
    
  }

  ngOnInit(): void {
  
    this.translate.addLangs(this.languageList);
    const currentUrl = window.location.href
    if(currentUrl.indexOf('aangiften') !== -1)
    {
      this.translate.setDefaultLang('NL');
      sessionStorage.setItem("currentlang", "NL")
    }
    else if(currentUrl.indexOf('declarations') !== -1)
    {
      this.translate.setDefaultLang('FR');
      sessionStorage.setItem("currentlang", "FR")
    }
    else if(currentUrl.indexOf('sofiaformstst1') !== -1)
    {
      this.translate.setDefaultLang('NL');
      sessionStorage.setItem("currentlang", "NL")
    }
    else if(currentUrl.indexOf('sofiaformstst') !== -1)
    {
      this.translate.setDefaultLang('FR');
      sessionStorage.setItem("currentlang", "FR")
    }
    else if(currentUrl.indexOf('sofiaformsacc1') !== -1)
    {
      this.translate.setDefaultLang('NL');
      sessionStorage.setItem("currentlang", "NL")
    }
    else if(currentUrl.indexOf('sofiaformsacc') !== -1)
    {
      this.translate.setDefaultLang('FR');
      sessionStorage.setItem("currentlang", "FR")
    }
    else{
      this.translate.setDefaultLang('NL');
      sessionStorage.setItem("currentlang", "NL")
    }
  }
}
